import { useLocation } from "react-router-dom";
import Localization from "../../localization";
import { useApi } from "../../hooks";
import { AuthApi } from "../../apis";

const useViewModel = () => {
  const { state } = useLocation();
  const { execute } = useApi();

  const sendContactRequest = async (data = {}) => {
    await execute(() =>
      AuthApi.connectFeedback({ ...data, deviceIdentifier: state.device.name })
    );
  };

  return {
    sendContactRequest,
    readUrl: state?.readUrl,
    title: state?.title ?? Localization.unsupported_device.default_title,
    desc:
      state?.description ?? Localization.unsupported_device.default_description,
  };
};

export default useViewModel;
